<!--<div *ngIf='screenWidth > 1230'>
    <div (window:orientationchange)="screenRotate($event)">
        <div class="bmw-lg-oss-home">-->
            <h1>{{ossLinkName}}</h1>
            <iframe *ngIf="ossSafe" [src]="ossSafe" width="1000px" height="700px" frameborder="0">

            </iframe>
            <!--
        </div>
    </div>
</div>-->